export const titleTxt = 'How it works';
export const stepOneMainTxt = 'Connect your wallet that holds one or more NFTs qualified for sacrifice.';
export const stepOneSubTxt = 'Unsure if you have one?';
export const stepOneSubClickableTxt = 'Check here';
export const stepTwoTxt =
  'Step inside and choose the NFT from your wallet to\nsacrifice for an Eternal Vikings Genesis NFT';
export const stepThreeTxt =
  'Once selected, proceed to the Sacrificial Temple and choose\nbetween Sacrifice&Stake or just Sacrifice';
